import './StatCard.css';

function StatCard({ title, value, subtitle, icon: Icon, trend, color = 'primary' }) {
  return (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className={`stat-card-icon ${color}`}>
          {Icon && <Icon className="w-6 h-6" />}
        </div>
        {trend && (
          <div className={`stat-card-trend ${trend.positive ? 'positive' : 'negative'}`}>
            <span>{trend.value}</span>
          </div>
        )}
      </div>
      <h3 className="stat-card-title">{title}</h3>
      <p className="stat-card-value">{value}</p>
      {subtitle && <p className="stat-card-subtitle">{subtitle}</p>}
    </div>
  );
}

export default StatCard;

